import React from "react";
import { Link } from "react-router-dom";
import SidebarContainer from "./sidebar.css";

function Sidebar({ Linkto, NowAddress }) {
  return (
    <SidebarContainer>
      <ul>
        {Linkto.map((data, index) => (
          <li key={index}>
            <Link to={`${NowAddress.path}/${data.address}`}>
              <p>{data.title}</p>
            </Link>
          </li>
        ))}
      </ul>
    </SidebarContainer>
  );
}

export default Sidebar;
